module.exports = __webpack_public_path__ + "fonts/FilsonPro-Bold.3e0deb2.eot";